<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="book-invoice-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Book Invoice
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="accountingSystemNumber"
                name="accounting_system_number"
                label="Accounting System Number"
                :error="getError('accounting_system_number')"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {TextFormGroup},

  mixins: [Errors],

  props: ['invoice'],

  data() {
    return {
      accountingSystemNumber: null
    }
  },

  mounted() {
    this.listenForClose()
  },
  methods: {
    listenForClose() {
      $('#book-invoice-modal').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/invoices/'+ this.invoice.id +'/book', { accounting_system_number: this.accountingSystemNumber})
          .then(response => {
            notify.success('The invoice was booked')

            this.$emit('booked', response.data.data)

            $('#book-invoice-modal').modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.accountingSystemNumber = null
    }
  }
}
</script>
